'use client'

import { FunctionComponent, useEffect } from 'react'

const ConsoleWelcomeMessage: FunctionComponent = () => {
  useEffect(() => {
    console.log('%cDeveloped by Supercosmic — https://super-cosmic.com', 'color: #fff; background: #000; padding: 4px 6px; font-size: 12px; border-radius: 4px;')
    console.log('This browser feature is intended for developers. Pasting anything here could give attackers access to your account.')
  }, [])

  return null
}

export default ConsoleWelcomeMessage
